import * as React from "react";
import { Route } from "react-router";
import { EventEmitter } from "fbemitter";

import { LabelStore } from "../flux/Label/LabelStore";
import { ListStore } from "../flux/Grid/ListStore";
import { SelectedItemsStore } from "../flux/Grid/SelectedItemsStore";
import { DeleteObjectsStore } from "../flux/DeleteObjects";
import { FlagStore } from "../flux/Flag/FlagStore";
import { ErrorStore } from "../flux/Error/ErrorStore";
import { EditServiceAccountStore } from "../components/Pages/ServiceAccount/EditServiceAccountStore";

import { DeleteObjectsCommand } from "../components/Pages/commands/DeleteObjects";
import { UpsertCommand } from "../components/Pages/commands/UpsertCommand";
import { InitUpsertServiceAccountCommand, UpsertServiceAccountCommand } from "../components/Pages/ServiceAccount/commands";

import { ServiceAccount, EntityType } from "../../models";
import { Polyglot } from "../../polyglot";
import { SearchFn } from "../../rest/Search";
import { CommitFn } from "../../rest/Commit";
import { DeleteObjectsFn } from "../../rest/DeleteObjects";
import { ServiceAccountRoute } from "../components/Pages/ServiceAccount/ServiceAccountRoute";
import { TabSearchConfigurator } from "./configureSearchBox";
import { routeFor } from "../routes";
import { SearchProps } from "../components/Pages/SearchProps";

// This class is a configuration for Service account tab
// Constructor receives and/or creates dependencies and injects them
export class ServiceAccountTab
{
    readonly listStore = new ListStore<ServiceAccount>(sa => sa.id, EntityType.ServiceAccount);
    
    private readonly tableTitleStore = new LabelStore();
    private readonly selectedItemsStore = new SelectedItemsStore(this.listStore, EntityType.ServiceAccount);
    private readonly toDeleteItemsStore = new DeleteObjectsStore(EntityType.ServiceAccount);
    private readonly upsertDivisionLoadInProgress = new FlagStore();
    private readonly upsertInProgressStore = new FlagStore();
    private readonly upsertErrorStore = new ErrorStore();
    private readonly editStore = new EditServiceAccountStore();

    readonly markup: JSX.Element;
    readonly searchConfig: TabSearchConfigurator;
        
    constructor(polyglot: Polyglot, runSearch: SearchFn, commitEntity: CommitFn, deleteObjects: DeleteObjectsFn, getCurrentDivisionId: () => number, divisionEmitter: EventEmitter, isDivisionAware: boolean)
    {
        this.searchConfig = new TabSearchConfigurator(polyglot, EntityType.ServiceAccount, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
        const deleteServiceAccountCommand = new DeleteObjectsCommand(EntityType.ServiceAccount, this.toDeleteItemsStore, deleteObjects);
        const preloadEditCreateServiceAccountCmd = new InitUpsertServiceAccountCommand(runSearch, this.editStore, getCurrentDivisionId, this.upsertErrorStore.dispatchToken, this.upsertDivisionLoadInProgress.dispatchToken);
        const internalUpsertServiceAccountCmd = new UpsertCommand(commitEntity, this.listStore.dispatchToken, this.upsertInProgressStore.dispatchToken, this.upsertErrorStore.dispatchToken);
        const upsertServiceAccountCmd = new UpsertServiceAccountCommand(polyglot, this.upsertErrorStore.dispatchToken, internalUpsertServiceAccountCmd);

        this.markup = (
            <Route path={routeFor(EntityType.ServiceAccount)} render={() => (
                <ServiceAccountRoute
                    polyglot={polyglot}
                    isAdmin={true}
                    isDivisionAware={isDivisionAware}
                    tableTitleStore={this.tableTitleStore}
                    listStore={this.listStore}
                    selectedItemsStore={this.selectedItemsStore}
                    deleteObjectsStore={this.toDeleteItemsStore}
                    deleteObjectsCommand={deleteServiceAccountCommand}

                    {...this.searchConfig.searchBoxProps}

                    loadDivisionInProgress={this.upsertDivisionLoadInProgress}
                    initUpsert={preloadEditCreateServiceAccountCmd}

                    upsertInProgressStore={this.upsertInProgressStore}
                    upsertErrorStore={this.upsertErrorStore}
                    upsertCommand={upsertServiceAccountCmd}
                    editStore={this.editStore}
                />
            )} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/init/serviceAccount.tsx